const React = require("react");
const T = require("prop-types");
const NavLink = require("react-router-dom").NavLink;

const image = require("images/measurements/highBust.jpg");
const { default: Dialog } = require("material-ui/Dialog");
const { default: RaisedButton } = require("material-ui/RaisedButton");
const { default: FlatButton } = require("material-ui/FlatButton");
const History = require("wiring/history");
const Classes = require("./styles.scss");

const internals = {};

internals.buttonLabelStyle = {
    textTransform: "inherit"
};

module.exports = class WhatsIncludedDialog extends React.PureComponent {
    static propTypes = {
        dialogOpen: T.bool.isRequired,
        onRequestDialogClose: T.func.isRequired,
        from: T.string,
        openPurchaseDialog: T.func
    };

    render() {
        const {
            dialogOpen,
            from,
            onRequestDialogClose,
            openPurchaseDialog
        } = this.props;

        const actions = [
            <div>
                <FlatButton
                    label="Got It"
                    onClick={onRequestDialogClose}
                    className={Classes.modalButton}
                />

                <RaisedButton
                    className={Classes.modalLink}
                    label="Buy Credits"
                    labelStyle={internals.buttonLabelStyle}
                    onClick={() => {
                        History.push("/buycredits");
                        if (from === "pricing") {
                            openPurchaseDialog();
                            onRequestDialogClose();
                        } else {
                            History.push("/buycredits?checkout");
                            onRequestDialogClose();
                        }
                    }}
                    primary
                />
            </div>
        ];

        return (
            <Dialog
                title={"What's Included"}
                actions={actions}
                open={dialogOpen}
                modal={false}
                onRequestClose={onRequestDialogClose}
                autoScrollBodyContent
                paperClassName={Classes.modal}
            >
                <div className={Classes.whatsIncluded}>
                    <div className={Classes.whatsIncludedImg} />
                    <div className={Classes.whatsIncludedCopy}>
                        <p>
                            Every purchase includes front &amp; back images of
                            your MyBodyModel and personalized Project Planner
                            PDF with multiple page formats with 1-12 models per
                            page.
                        </p>

                        <ul>
                            <p>BASIC (1 credit)</p>
                            <li>1 line color</li>
                            <li>Arms down pose</li>
                        </ul>

                        <ul>
                            <p>PREMIUM (2 credits)</p>
                            <li>5 line colors</li>
                            <li>Arms down pose</li>
                            <li>Hand on hip pose</li>
                        </ul>

                        <p className={Classes.noticeCopy}>
                            Expecting your measurements to change? Get a
                            discount pack and save leftover Credits for later.
                        </p>
                    </div>
                </div>
            </Dialog>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/Dialog/WhatsIncludedDialog.js